import {
  faCircleCheck as faCircle,
  faDoorOpen,
  faStore,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import RegisterModal from "./registerModal";
import { toast } from "react-toastify";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import { EMenuActions } from "../../store";

export default function Index() {
  const [reg, setReg] = useState(false);
  const waiterScreen = useLocation().pathname.split("/")[2];

  let dispatch = useDispatch();

  const deliveryMethod = useSelector((state) => state.EMenu.deliveryMethod);

  let navigate = useNavigate();

  const handleNav = () => {
    if (deliveryMethod === "outdoor") {
      setReg(!reg);
    } else if (deliveryMethod === "indoor") {
      navigate("/payment");
    } else if (deliveryMethod === "") {
      toast.error("Select a Delivery Method", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: "light",
      });
    }
  };
  const handleReg = () => {
    navigate("/customer-reg");
  };

  const handleDelivery = (value) => {
    dispatch(EMenuActions.setDeliveryMethod(value));
  };

  return (
    <div className="h-[20%]">
      <p className="font-black text-xl uppercase text-dark/60">
        Delivery Method
      </p>

      <div className=" py-5 flex flex-col my-auto rounded-md place-self-center">
        <div className="">
          <div className="flex flex-col gap-4 mb-5">
            <button
              id="indoor"
              onClick={(e) => handleDelivery(e.target.id)}
              className={`cursor-pointer w-[100%] m-auto p-4 border-4 ${
                deliveryMethod === "indoor"
                  ? "border-secondary"
                  : "border-light"
              } rounded-lg flex justify-between gap-3 text-left items-center`}
            >
              <FontAwesomeIcon
                id="indoor"
                onClick={(e) => handleDelivery(e.target.id)}
                icon={faStore}
                size="2xl"
                className={`${
                  deliveryMethod === "indoor"
                    ? "text-secondary"
                    : "text-dark/50"
                } `}
              />
              <div className="w-[70%]">
                <p
                  id="indoor"
                  onClick={(e) => handleDelivery(e.target.id)}
                  className={`${
                    deliveryMethod === "indoor" ? "text-secondary" : null
                  } font-extrabold text-md`}
                >
                  Indoor
                </p>
                <span
                  id="indoor"
                  onClick={(e) => handleDelivery(e.target.id)}
                  className={`${
                    deliveryMethod === "indoor"
                      ? "text-secondary"
                      : "text-dark/50"
                  } text-sm `}
                >
                  Are you placing order within the restaurant?
                </span>
              </div>
              <div className="w-[10%]">
                <FontAwesomeIcon
                  id="indoor"
                  onClick={(e) => handleDelivery(e.target.id)}
                  icon={deliveryMethod === "indoor" ? faCircle : faCircleCheck}
                  size="2xl"
                  className={
                    deliveryMethod === "indoor"
                      ? "text-secondary"
                      : "text-primaryLight"
                  }
                />
              </div>
            </button>
            {waiterScreen !== "waiterscreen" && (
              <button
                id="outdoor"
                onClick={(e) => handleDelivery(e.target.id)}
                className={`cursor-pointer w-[100%] m-auto p-4 border-4 ${
                  deliveryMethod === "outdoor"
                    ? "border-secondary"
                    : "border-light"
                } rounded-lg flex justify-between gap-3 text-left items-center`}
              >
                <FontAwesomeIcon
                  id="outdoor"
                  onClick={(e) => handleDelivery(e.target.id)}
                  icon={faDoorOpen}
                  size="2xl"
                  className={`${
                    deliveryMethod === "outdoor"
                      ? "text-secondary"
                      : "text-dark/50"
                  }`}
                />
                <div className="w-[70%]">
                  <p
                    id="outdoor"
                    onClick={(e) => handleDelivery(e.target.id)}
                    className={`${
                      deliveryMethod === "outdoor" ? "text-secondary" : null
                    } font-extrabold text-md text-left`}
                  >
                    Outdoor
                  </p>
                  <span
                    id="outdoor"
                    onClick={(e) => handleDelivery(e.target.id)}
                    className={`${
                      deliveryMethod === "outdoor"
                        ? "text-secondary"
                        : "text-dark/50"
                    } text-sm`}
                  >
                    Are you outside our restaurant?
                  </span>
                </div>
                <div className="w-[10%]">
                  <FontAwesomeIcon
                    id="outdoor"
                    onClick={(e) => handleDelivery(e.target.id)}
                    icon={
                      deliveryMethod === "outdoor" ? faCircle : faCircleCheck
                    }
                    size="2xl"
                    className={
                      deliveryMethod === "outdoor"
                        ? "text-secondary"
                        : "text-primaryLight"
                    }
                  />
                </div>
              </button>
            )}
          </div>
        </div>
      </div>
      {reg ? <RegisterModal handleClick={handleReg} /> : null}
    </div>
  );
}
